import { cn } from './primitives.tsx';

/** Original brand mark: five staff lines with a rising note path. Name comes from app config. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8', className)} aria-hidden="true">
      <rect width="32" height="32" rx="9" fill="var(--color-primary)" />
      <g stroke="#fff" strokeOpacity="0.45" strokeWidth="1.2">
        <path d="M6 10h20M6 13.5h20M6 17h20M6 20.5h20M6 24h20" />
      </g>
      <ellipse cx="12" cy="20.5" rx="3" ry="2.2" fill="#fff" transform="rotate(-20 12 20.5)" />
      <ellipse cx="21" cy="13.5" rx="3" ry="2.2" fill="var(--color-brass)" transform="rotate(-20 21 13.5)" />
    </svg>
  );
}
